module.exports = __webpack_public_path__ + "static/media/salad-vegetable-02.1a07ab37.png";